var brand_swiper = new Swiper(".block_brand-logo-slider", {
  slidesPerView: 8,
   loop: true,
  grid: {
    rows: 2,
  },
  navigation: {
    nextEl: ".block_shop-by-brand .block_slider-right-arrow",
    prevEl: ".block_shop-by-brand .block_slider-left-arrow",
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      autoplay: {
        delay: 3000, // Autoplay every 3 seconds
        disableOnInteraction: false,
      },
    },
    399: {
      slidesPerView: 3,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    749: {
      slidesPerView: 4,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    1280: {
      slidesPerView: 5,
      autoplay: false, // Disable autoplay on larger screens
    },
    1366: {
      slidesPerView: 6,
      autoplay: false,
    },
    1499: {
      slidesPerView: 8,
      autoplay: false,
    },
  },
});
  if (window.innerWidth < 1025) {
    brand_swiper.autoplay.start();
  }